import { CustomRiskLevel } from "src/core/constants/risk";
import { cn } from "src/core/lib/utils";
import { getRiskClass } from "src/core/utils/riskClass";

export const CartographyRow = ({
  icon,
  branchLabel,
  branchRisk,
  isHeader,
  criteriaRisk,
  detailLabel,
}: {
  icon?: React.ReactNode;
  branchLabel?: string;
  branchRisk?: CustomRiskLevel;
  isHeader?: boolean;
  criteriaRisk?: CustomRiskLevel;
  detailLabel?: string;
}) => {
  return (
    <>
      {branchLabel && branchRisk ? (
        <div
          className={cn(
            "col-span-4 min-h-[30px] flex flex-row items-center gap-x-10",
            getRiskClass("icon", branchRisk)
          )}
          data-testid="cartography-branch-cell"
        >
          {icon}
          {branchLabel}
        </div>
      ) : (
        <div className="col-span-4 min-h-[30px] flex flex-row items-center gap-x-10"></div>
      )}
      <div
        className={cn(
          "col-span-8 min-h-[30px] flex items-center gap-x-5",
          isHeader && "border-b border-border"
        )}
        data-testid="cartography-criteria-cell"
      >
        <>
          {criteriaRisk && (
            <span
              className={cn("w-[16px] h-[16px] rounded-full", getRiskClass("dot", criteriaRisk))}
              data-testid="cartography-criteria-risk-cell"
            ></span>
          )}
          {detailLabel ?? ""}
        </>
      </div>
    </>
  );
};
